import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { notify } from "../../../utils/shared";
const API_URL = process.env.REACT_APP_API_URL;
const GET_ALL_FORUMS = `${API_URL}/forums/getAllForums`;
const ADD_FORUM_DETAILS = `${API_URL}/forums`;
const UPDATE_FORUM_DETAILS = `${API_URL}/forums/admin/`;
const COMMENT_PATH = `${API_URL}/forums/admin/comment`;

export const getForums = createAsyncThunk(
  "getForums",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page, limit, search = '' } = values
      const { data } = await axios.get(`${GET_ALL_FORUMS}?page=${page}&limit=${limit}&search=${search}`, {});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateForumDetails = createAsyncThunk(
  "updateForumDetails",
  async ({values, id, page}: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${UPDATE_FORUM_DETAILS}${id}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getForums({page: page || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addForumDetails = createAsyncThunk(
  "addForumDetails",
  async ({values,page}: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${ADD_FORUM_DETAILS}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getForums({ page: page || 1, limit: 10 }))
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);


export const deleteForum = createAsyncThunk(
  "deleteForum",
  async (values: any, { rejectWithValue, dispatch }) => { 
    try {
      const { data } = await axios.delete(`${UPDATE_FORUM_DETAILS}${values.id}`);
      notify(data.responseMessage, 'success'); 
      dispatch(getForums({page: values.selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const deleteForumComment = createAsyncThunk(
  "deleteForumComment",
  async (values: any, { rejectWithValue, dispatch }) => { 
    try {
      const { data } = await axios.delete(`${COMMENT_PATH}/${values.id}`);
      notify(data.responseMessage, 'success'); 
      dispatch(getForums({page: values.selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);
